import React from 'react'
import { Circles } from  'react-loader-spinner'
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import PropTypes from 'prop-types'
function Loader(props) {  
    const {isMargin} = props

	return (
        <div className={`${isMargin ? 'mb-2' : 'm-5 p-5 '} loader d-flex justify-content-center align-item-center`}>
            <Circles
                height={isMargin ? '20' : '40'}
                width={isMargin ? '20' : '40'}
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>
        
        )
}
Loader.propTypes = {
	
	eventsLoader: PropTypes.bool,
    isMargin: PropTypes.bool,
}

Loader.defaulProps = {
	
	eventsLoader: false,
    isMargin: ''
	
}
export default Loader
